import {
  boolean, date, nullable, string,
} from '@sda/sdk/helpers/types.bitmasks';

export const PublicTicketMask = {
  showId: string,
  stripeSKU: string,
  status: string,
  reservedUntil: date | nullable,
  fingerprint: string,
  hash: string | nullable,
  isBogo: boolean,
  bogoIsRedeemed: boolean,
  isCompedTicket: boolean,

  createdAt: date,
  privateUpdatedAt: date,
  updatedAt: date,
};
